import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Materials = lazy(() => import('../pages/materials/page'));
const MaterialDetail = lazy(() => import('../pages/materials/detail/page'));
const Sites = lazy(() => import('../pages/sites/page'));
const SiteDetail = lazy(() => import('../pages/sites/detail/page'));
const Questions = lazy(() => import('../pages/questions/page'));
const QuestionDetail = lazy(() => import('../pages/questions/detail/page'));
const NewQuestion = lazy(() => import('../pages/questions/new/page'));
const Voices = lazy(() => import('../pages/voices/page'));
const VoiceDetail = lazy(() => import('../pages/voices/detail/page'));
const NewVoice = lazy(() => import('../pages/voices/new/page'));
const Recipes = lazy(() => import('../pages/recipes/page'));
const RecipeDetail = lazy(() => import('../pages/recipes/detail/page'));
const NewRecipe = lazy(() => import('../pages/recipes/new/page'));
const Features = lazy(() => import('../pages/features/page'));
const JhsFreePrint = lazy(() => import('../pages/features/jhs-free-print/page'));
const MathSummary = lazy(() => import('../pages/features/math-summary/page'));
const EnglishSummary = lazy(() => import('../pages/features/english-summary/page'));
const JapaneseSummary = lazy(() => import('../pages/features/japanese-summary/page'));
const ScienceSummary = lazy(() => import('../pages/features/science-summary/page'));
const SocialSummary = lazy(() => import('../pages/features/social-summary/page'));
const AdsJhsFree = lazy(() => import('../pages/ads/jhs-free/page'));
const HelpfulRecipes = lazy(() => import('../pages/account/helpful-recipes/page'));
const MyRecipes = lazy(() => import('../pages/account/my-recipes/page'));
const MyMaterials = lazy(() => import('../pages/account/my-materials/page'));
const MyReviews = lazy(() => import('../pages/account/my-reviews/page'));
const Admin = lazy(() => import('../pages/admin/page'));
const Login = lazy(() => import('../pages/login/page'));
const About = lazy(() => import('../pages/about/page'));
const Feedback = lazy(() => import('../pages/feedback/page'));
const Terms = lazy(() => import('../pages/terms/page'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/materials',
    element: <Materials />,
  },
  {
    path: '/materials/:slug',
    element: <MaterialDetail />,
  },
  {
    path: '/sites',
    element: <Sites />,
  },
  {
    path: '/sites/:slug',
    element: <SiteDetail />,
  },
  {
    path: '/questions',
    element: <Questions />,
  },
  {
    path: '/questions/:id',
    element: <QuestionDetail />,
  },
  {
    path: '/questions/new',
    element: <NewQuestion />,
  },
  {
    path: '/worries',
    element: <Navigate to="/voices" replace />,
  },
  {
    path: '/voices',
    element: <Voices />,
  },
  {
    path: '/voices/:id',
    element: <VoiceDetail />,
  },
  {
    path: '/voices/new',
    element: <NewVoice />,
  },
  {
    path: '/recipes',
    element: <Recipes />,
  },
  {
    path: '/recipes/:id',
    element: <RecipeDetail />,
  },
  {
    path: '/recipes/new',
    element: <NewRecipe />,
  },
  {
    path: '/features',
    element: <Features />,
  },
  {
    path: '/features/jhs-free-print',
    element: <JhsFreePrint />,
  },
  {
    path: '/features/math-summary',
    element: <MathSummary />,
  },
  {
    path: '/features/english-summary',
    element: <EnglishSummary />,
  },
  {
    path: '/features/japanese-summary',
    element: <JapaneseSummary />,
  },
  {
    path: '/features/science-summary',
    element: <ScienceSummary />,
  },
  {
    path: '/features/social-summary',
    element: <SocialSummary />,
  },
  {
    path: '/ads/jhs-free',
    element: <AdsJhsFree />,
  },
  {
    path: '/account/helpful-recipes',
    element: <HelpfulRecipes />,
  },
  {
    path: '/account/my-recipes',
    element: <MyRecipes />,
  },
  {
    path: '/account/my-materials',
    element: <MyMaterials />,
  },
  {
    path: '/account/my-reviews',
    element: <MyReviews />,
  },
  {
    path: '/admin',
    element: <Admin />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/feedback',
    element: <Feedback />,
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
